import { proxy } from 'valtio';

const historyState = proxy<{
    undoCount: number;
    redoCount: number;
}>({
    undoCount: 0,
    redoCount: 0,
});

export { historyState };
